'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _selections = require('./selections.html');

var _selections2 = _interopRequireDefault(_selections);

var _selectionDetail = require('./selectionDetail.html');

var _selectionDetail2 = _interopRequireDefault(_selectionDetail);

var _selectionPurchase = require('./selectionPurchase.html');

var _selectionPurchase2 = _interopRequireDefault(_selectionPurchase);

var _selectionsAllPurchasable = require('./selectionsAllPurchasable.html');

var _selectionsAllPurchasable2 = _interopRequireDefault(_selectionsAllPurchasable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
var SelectionsConfig = function SelectionsConfig($stateProvider) {
    $stateProvider.state('selections', {
        url: '/selections',
        template: _selections2.default,
        controller: 'SelectionsController',
        controllerAs: 'selections',
        resolve: {
            init: function init($ionicConfig) {
                $ionicConfig.scrolling.jsScrolling(false);
            }
        }
    }).state('selectionDetail', {
        url: '/selections/:selectionId',
        template: _selectionDetail2.default,
        controller: 'SelectionDetailController',
        controllerAs: 'selection'
    }).state('selectionsAllPurchasable', {
        url: '/selectionsPurchasable/all',
        params: { showHelp: null },
        template: _selectionsAllPurchasable2.default,
        controller: 'SelectionsAllPurchasableController',
        controllerAs: 'selections',
        resolve: {
            init: function init($ionicConfig) {
                $ionicConfig.scrolling.jsScrolling(false);
            }
        }
    }).state('selectionPurchase', {
        url: '/selectionsPurchasable/:selectionId',
        template: _selectionPurchase2.default,
        controller: 'SelectionPurchaseController',
        controllerAs: 'selectionPurchase'
    });
};

exports.default = SelectionsConfig;


/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selections.config.js
 **/